<div class="load-content"></div>
<div id="containerProgressVar" class="border-all" apply="theme" border="theme">
	<div id="imgBlack"></div>
	<div id="imgTheme" apply="theme" filter="theme">
	</div>
</div>
<span tag-style="theme" class="new badge progressValue" data-badge-caption="" apply="theme">
	<p class="margin-all-0">{{loadText}}... {{percent | number:'1.0-0'}}%</p>
</span>